<template>
  <a-spin :spinning="submitting">
    <label
        class="block text-lg font-bold text-black"
    >Max Vote </label
    >
    <div class="mt-1">
      <input
          :disabled="!canChange"
          type="number"
          v-model="maxVote"
          name="game-name"
          id="survey-question"
          class="shadow focus:ring-indigo-500 focus:border-blue-400 block w-full sm:text-sm border-gray-300 rounded-md"
          placeholder="Survey question"
      />
      <button @click="updateItem" v-if="canChange"
              class=" mt-2 px-1 py-1 rounded shadow bg-blue-400 hover:bg-blue-200 text-white font-bold text-md ">Save
      </button>
    </div>
  </a-spin>

</template>

<script>
import {ref} from "vue";
import {message} from "ant-design-vue";


export default {
  props: ['canChange', 'room_id', 'maxVote'],
  components: {},
  data() {
    return {};
  },
  setup(props, {emit}) {
    const submitting = ref(false);

    const updateItem = () => {
      // lists.value[listId].cards.push({ text: newText, id: new Date().getTime() });
      submitting.value = true;
      axios
          .put(route("retrospective.room.update.vote"), {
            room_id: props.room_id,
            max_votes: props.maxVote,
          })
          .then((response) => {
            submitting.value = false
            message.success("Your max vote is updated.");
            emit('maxVoteUpdated');
          })
          .catch((error) => {
            submitting.value = false;
            console.log(error);
            message.error("Oops, something went wrong.");
          });
    };

    return {
      updateItem,
      submitting,
    }
  },
  computed: {},
  methods: {}
};
</script>
<style scoped>

.ant-spin-nested-loading {
  height: unset !important;
}
</style>
